(function () {
  function init() {
    var el = document.querySelector('.ws-stars');
    var widget = document.getElementById('judgeme_product_reviews');
    if (!el || !widget) return;

    el.style.cursor = 'pointer';

    function scrollToWidget() {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    el.addEventListener('click', scrollToWidget);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToWidget();
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
